import React, { useState, useMemo } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Heart, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import client from "../lib/api";
import Footer from "../components/Footer";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get("token") || "", [params]);
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) {
      toast.error("A palavra-passe deve ter pelo menos 6 caracteres.");
      return;
    }
    if (pw !== confirm) {
      toast.error("As palavras-passe não coincidem.");
      return;
    }
    setBusy(true);
    try {
      await client.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 2400);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível alterar a palavra-passe.");
    } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex flex-col bg-[#0C0E12]">
        <div className="flex-1 flex items-center justify-center px-6 py-16">
          <div className="w-full max-w-md text-center">
            <h1 className="font-display text-3xl mb-4">Link inválido</h1>
            <p className="text-[#A29F9B] mb-6">
              O link de recuperação está em falta ou foi truncado.
            </p>
            <Link to="/esqueci-password" className="text-[#C5A880] hover:underline" data-testid="reset-no-token-link">
              Pedir novo link
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#0C0E12]" data-testid="reset-password-page">
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 justify-center mb-10">
            <Heart className="w-5 h-5 text-[#C5A880]" />
            <span className="font-display text-2xl">Soulmatch</span>
          </Link>

          <div className="bg-[#161920] border border-white/5 rounded-2xl p-10">
            {done ? (
              <div className="text-center" data-testid="reset-success">
                <CheckCircle2 className="w-12 h-12 text-[#C5A880] mx-auto mb-4" />
                <h1 className="font-display text-2xl mb-3">Palavra-passe actualizada</h1>
                <p className="text-[#A29F9B] text-sm">A redirecionar para o login...</p>
              </div>
            ) : (
              <>
                <span className="label-uppercase">Nova palavra-passe</span>
                <h1 className="font-display text-3xl mt-3 mb-8">Define a tua nova palavra-passe</h1>

                <form onSubmit={submit} className="space-y-6">
                  <div>
                    <label className="text-xs text-[#A29F9B]">Nova palavra-passe</label>
                    <input
                      type="password"
                      required
                      minLength={6}
                      value={pw}
                      onChange={(e) => setPw(e.target.value)}
                      className="input-elegant"
                      placeholder="Mínimo 6 caracteres"
                      data-testid="reset-password-new"
                      autoFocus
                    />
                  </div>
                  <div>
                    <label className="text-xs text-[#A29F9B]">Confirmar palavra-passe</label>
                    <input
                      type="password"
                      required
                      minLength={6}
                      value={confirm}
                      onChange={(e) => setConfirm(e.target.value)}
                      className="input-elegant"
                      placeholder="Repete a palavra-passe"
                      data-testid="reset-password-confirm"
                    />
                  </div>
                  <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="reset-submit">
                    {busy ? "A guardar..." : "Guardar nova palavra-passe"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPassword;
